module.exports = __webpack_public_path__ + "img/borderLeftArrow2White.90caa97e.svg";